module.exports = __webpack_public_path__ + "static/media/client6.80308109.svg";